<template>
  <skutopia>
    <v-card class="mb-6">
        <v-card-text>
            <v-row>
                <v-col
                v-for="(data, index) in summaryCards"
                :key="index"
                cols="12"
                sm="6"
                md="4"
                class="pr-6"
                >
                <div class="d-flex">
                    <div class="d-flex flex-column gap-y-1">
                    <p class="text-capitalize mb-0">
                        {{ data.label }}
                    </p>
                    <h6 class="text-h4">
                        {{ data.count }}
                    </h6>
                    </div>
                    <v-spacer></v-spacer>
                    <v-avatar
                    :color="data.color"
                    rounded
                    outlined
                    size="44"
                    >
                    <v-icon size="28" color="white">
                        {{ data.icon }}
                    </v-icon>
                    </v-avatar>
                    <v-divider
                        vertical
                        inset
                        class="ml-6 my-0"
                        v-if="index !== summaryCards.length - 1 ? true : false"
                    />
                </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    <v-card >
        <v-card-title>
            POG List
        </v-card-title>
        <!-- actions -->
         <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="4">
                    <v-autocomplete
                        v-model="selectedCategory"
                        :items="categoryOptions"
                        :loading="categoryLoading"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        label="Project Category"
                        placeholder="Select Category"
                        clearable
                        @change="changeCategory"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-autocomplete
                        v-model="selectedMarkets"
                        :items="getFacetOptions('markets')"
                        item-text="label"
                        label="Market"
                        outlined
                        chips
                        dense
                        hide-details
                        clearable
                        multiple
                        deletable-chips
                        @change="filterChange"
                    >
                        <template v-slot:item="{ item }">
                            {{ item.label }} ({{ item.count }})
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-autocomplete
                        v-model="selectedBrands"
                        :items="getFacetOptions('brands')"
                        item-text="label"
                        label="Brand"
                        outlined
                        chips
                        dense
                        hide-details
                        clearable
                        multiple
                        deletable-chips
                        @change="filterChange"
                    >
                        <template v-slot:item="{ item }">
                            {{ item.label }} ({{ item.count }})
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
         </v-card-text>
        <v-card-text class="d-flex align-center flex-wrap pb-0 mt-4">
          <v-row>
            <!-- search -->
            <v-col
              cols="12"
              sm="4"
            >
            <v-form
                @submit="submitSearch($event)"
            >
                <v-text-field
                    v-model="searchQuery"
                    placeholder="Search"
                    outlined
                    hide-details
                    dense
                    clearable
                    class="mb-4"
                    :append-icon="icons.mdiSend"
                    @click:append="submitSearch"
                    @click:append-outer="submitSearch"
                    @click:clear="submitSearch(event=null)"
                >
                </v-text-field>

            </v-form>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center">
            <v-checkbox
                v-model="pogCompletedStatus"
                label="Show completed only"
                hide-details
                dense
                class="mb-4 mt-0 pt-0"
                @change="submitSearch"
            ></v-checkbox>
        </v-col>
          <v-col
              cols="12"
              sm="4"
            >
                <div
                    class=" d-flex flex-column align-end"
                >
                    <v-btn
                        :prepend-icon="icons.mdiDownload"
                        dense
                        color="primary"
                        @click="isUploadDialogVisible = !isUploadDialogVisible"
                        v-if="$can('update','skutopia')"
                    >
                        Upload New POG
                    </v-btn>
                </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-dialog v-model="validationDialogOpen" max-width="900px" persistent>
  <v-card>
    <v-card-title class="d-flex align-center">
      Validate Planogram Products
      <v-spacer />
      <v-chip small :color="validationAllResolved ? 'success' : 'warning'">
        {{ validationResolvedCount }} / {{ validationRows.length }} resolved
      </v-chip>
    </v-card-title>

    <v-card-subtitle class="pt-1 pb-0">
      Review each product below. Confirm the correct match or mark as "No Product Found".
    </v-card-subtitle>

    <v-card-text v-if="validationLoading" class="d-flex justify-center align-center py-10">
      <v-progress-circular indeterminate color="primary" />
    </v-card-text>

    <v-card-text v-else>
      <v-row class="mb-4" dense>
        <v-col>
          <v-chip small color="success" class="mr-2">{{ validationExactCount }} exact</v-chip>
          <v-chip small color="warning" class="mr-2">{{ validationPartialCount }} need review</v-chip>
          <v-chip small color="error">{{ validationNoneCount }} no match</v-chip>
        </v-col>
      </v-row>

      <div v-if="validationRowsNeedingReview.length > 0">
        <div class="text-subtitle-2 font-weight-bold mb-3 error--text">
          <v-icon small color="error" class="mr-1">{{ icons.mdiAlertCircle }}</v-icon>
          {{ validationRowsNeedingReview.length }} product(s) need your attention
        </div>

        <div v-for="row in validationRowsNeedingReview" :key="row.row_index" class="mb-4">
          <v-card
            outlined
            :class="{
              'border-warning': row.match_type === 'partial' && !validationConfirmations[row.row_index],
              'border-error': row.match_type === 'none' && !validationConfirmations[row.row_index],
              'border-success': !!validationConfirmations[row.row_index],
            }"
          >
            <v-card-text class="pb-2">
              <div class="d-flex align-center mb-3">
                <v-chip x-small class="mr-2" color="primary" dark>Shelf {{ row.shelf }}</v-chip>
                <span class="text-body-2 font-weight-medium">{{ row.variant }}</span>
                <span class="mx-2 grey--text">·</span>
                <span class="text-caption grey--text">UPC: {{ row.upc }}</span>
                <span class="mx-2 grey--text">·</span>
                <span class="text-caption grey--text">Brand: {{ row.brand }}</span>
                <v-spacer />
                <v-chip x-small :color="row.match_type === 'partial' ? 'warning' : 'error'">
                  {{ row.match_type === 'partial' ? 'Partial match' : 'No match found' }}
                </v-chip>
              </div>

              <v-row dense v-if="row.matches.length">
                <v-col v-for="match in row.matches" :key="match.id" cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 d-flex flex-column align-center text-center"
                    :style="validationConfirmations[row.row_index] &&
                      validationConfirmations[row.row_index].confirmed_product_id === match.id
                      ? 'border-color: #4caf50;' : ''"
                    @click="validationSelectMatch(row, match)"
                  >
                    <v-avatar size="64" rounded class="mb-2">
                      <SecureImage v-if="match.thumbnail" :src="match.thumbnail" contain />
                      <v-icon v-else size="40" color="grey lighten-1">{{ icons.mdiPackageVariant }}</v-icon>
                    </v-avatar>
                    <div class="text-body-2 font-weight-medium">{{ match.name }}</div>
                    <div class="text-caption grey--text">{{ match.barcode }}</div>
                    <div class="text-caption">{{ match.brand }}</div>
                    <v-btn
                      x-small outlined class="mt-2"
                      :color="validationConfirmations[row.row_index] &&
                        validationConfirmations[row.row_index].confirmed_product_id === match.id
                        ? 'success' : 'primary'"
                      @click.stop="validationSelectMatch(row, match)"
                    >
                      {{ validationConfirmations[row.row_index] &&
                        validationConfirmations[row.row_index].confirmed_product_id === match.id
                        ? '✓ Confirmed' : 'Please confirm' }}
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>

              <div v-else class="text-center py-4 grey--text">
                No products found for UPC <strong>{{ row.upc }}</strong>.
              </div>

              <div class="d-flex justify-end mt-3">
                <v-btn
                  x-small text
                  :color="validationConfirmations[row.row_index] &&
                    validationConfirmations[row.row_index].confirmed_product_id === null ? 'error' : 'grey'"
                  @click="validationMarkNoProduct(row)"
                >
                  <v-icon left x-small>{{ icons.mdiClose }}</v-icon>
                  {{ validationConfirmations[row.row_index] &&
                    validationConfirmations[row.row_index].confirmed_product_id === null
                    ? 'Marked: No product' : 'No product found' }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>

      <v-alert v-else type="success" dense text class="mb-4">
        All products have exact UPC matches — no action needed. You can confirm and save, or expand below to review individual matches.
      </v-alert>

      <div v-if="validationExactCount > 0">
        <v-btn
          text
          small
          class="mb-2 pl-0"
          @click="exactMatchesExpanded = !exactMatchesExpanded"
        >
          <v-icon small class="mr-1">
            {{ exactMatchesExpanded ? icons.mdiChevronUp : icons.mdiChevronDown }}
          </v-icon>
          {{ exactMatchesExpanded ? 'Hide' : 'Show' }} {{ validationExactCount }} exact match{{ validationExactCount !== 1 ? 'es' : '' }}
        </v-btn>

        <div v-if="exactMatchesExpanded">
          <div v-for="row in validationRowsExact" :key="row.row_index" class="mb-2">
            <v-card outlined class="border-success">
              <v-card-text class="py-2">
                <div class="d-flex align-center">
                  <v-chip x-small class="mr-2" color="primary" dark>Shelf {{ row.shelf }}</v-chip>
                  <v-avatar size="28" rounded class="mr-2">
                    <SecureImage v-if="row.matches[0].thumbnail" :src="row.matches[0].thumbnail" contain />
                    <v-icon v-else small>{{ icons.mdiPackageVariant }}</v-icon>
                  </v-avatar>
                  <div class="d-flex flex-column">
                    <span class="text-body-2 font-weight-medium">{{ row.matches[0].name }}</span>
                    <span class="text-caption grey--text">{{ row.matches[0].barcode }} · {{ row.matches[0].brand }}</span>
                  </div>
                  <v-spacer />
                  <v-icon color="success" small>{{ icons.mdiCheckCircle }}</v-icon>
                  <v-btn x-small text class="ml-2" @click="toggleRowExpand(row.row_index)">
                    {{ expandedRows[row.row_index] ? 'Cancel' : 'Change' }}
                  </v-btn>
                </div>

                <div v-if="expandedRows[row.row_index]" class="mt-3">
                  <v-row dense>
                    <v-col v-for="match in row.matches" :key="match.id" cols="12" sm="6" md="4">
                      <v-card
                        outlined
                        class="pa-2 d-flex flex-column align-center text-center"
                        :style="validationConfirmations[row.row_index] &&
                          validationConfirmations[row.row_index].confirmed_product_id === match.id
                          ? 'border-color: #4caf50;' : ''"
                        @click="validationSelectMatch(row, match)"
                      >
                        <div class="text-caption font-weight-medium">{{ match.name }}</div>
                        <div class="text-caption grey--text">{{ match.barcode }}</div>
                        <v-btn x-small outlined class="mt-1"
                          :color="validationConfirmations[row.row_index] &&
                            validationConfirmations[row.row_index].confirmed_product_id === match.id
                            ? 'success' : 'primary'"
                          @click.stop="validationSelectMatch(row, match)"
                        >
                          {{ validationConfirmations[row.row_index] &&
                            validationConfirmations[row.row_index].confirmed_product_id === match.id
                            ? '✓ Confirmed' : 'Confirm' }}
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-3">
                    <v-btn
                        x-small text
                        :color="validationConfirmations[row.row_index] &&
                        validationConfirmations[row.row_index].is_excluded ? 'error' : 'grey'"
                        @click="validationMarkNoProduct(row)"
                    >
                        <v-icon left x-small>{{ icons.mdiClose }}</v-icon>
                        {{ validationConfirmations[row.row_index] &&
                        validationConfirmations[row.row_index].is_excluded
                        ? 'Marked: Not found' : 'No product found' }}
                    </v-btn>
                    </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </v-card-text>

    <!-- Updated Actions Area -->
    <v-card-actions class="px-4 pb-4">
      <v-btn text outlined @click="validationCancel">Cancel</v-btn>
      
      <!-- Bulk "Mark remaining as Not Found" Action -->
      <v-btn
        v-if="!validationAllResolved"
        text
        color="error"
        class="ml-3"
        @click="validationMarkRemainingAsNoProduct"
      >
        <v-icon left small>{{ icons.mdiCloseBoxMultipleOutline }}</v-icon>
        Mark remaining as "Not Found"
      </v-btn>

      <v-spacer />
      
      <span class="text-caption grey--text mr-4" v-if="!validationAllResolved">
        {{ validationRows.length - validationResolvedCount }} rows still need a decision
      </span>
      
      <v-btn
        color="primary" outlined
        :loading="validationConfirming"
        :disabled="!validationAllResolved || validationConfirming"
        @click="validationSubmit"
      >
        Confirm All & Save
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
        <v-card-text class="px-0">

            <!-- table -->
            <v-data-table
                :headers="POGHeaders"
                :items="planogramsData"
                :server-items-length="totalPOGs"
                :loading="pogLoading"
                :options.sync="options"
                :footer-props="{
                    'items-per-page-options':[options.itemsPerPage],
                    'disable-items-per-page': true,
                }"
            >

                <!-- POG ID -->
                <template #item.id="{ item }">
                    <router-link :to="{ name: 'planogram-id', params: { id: item.id } }">
                        #{{ item.id }}
                    </router-link>

                </template>

                <!-- Date -->
                <template #item.project="{ item }">
                    <div class="d-flex align-center gap-x-4 cursor-pointer"

                    >
                        <v-avatar
                            v-if="item.shelf_thumbnail"
                            size="38"
                            rounded
                            class="mr-3"
                            @click="openOverlay(item)"
                        >
                            <SecureImage
                                :alt="item.shelf_thumbnail"
                                :src="item.shelf_thumbnail"
                                contain
                            ></SecureImage>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span>{{ item.name }}</span>
                            <span>{{ item.project }} - {{ item.country }}</span>
                        </div>
                    </div>
                </template>
                <template #item.category="{ item }">
                    <div class="d-flex flex-column">
                        <span class="text-small" v-if="item.category">{{ item.category }}</span>
                        <small v-if="item.country">@{{ item.country }}</small>
                    </div>
                </template>
                <!-- Date -->
                <template #item.created_at="{ item }">
                    {{ new Date(item.created_at).toDateString() }}
                </template>


                <!-- Products -->
                <template #item.products="{ item }">
                <div
                    class="d-flex align-center font-weight-medium"
                >
                    <v-icon
                        size="10"
                        class="me-2"
                        :color="resolveStatus(item.status).color"
                    >{{icons.mdiCircle}}</v-icon>
                    <div class="d-flex flex-column">
                        <span>{{ item.products }} products</span>
                        <span
                            v-if="item.missing_images > 0 && item.status !== 'COMP'"
                            class="error--text">
                            {{ item.missing_images }} missing
                        </span>
                    </div>
                </div>
                </template>

                <!-- Status -->
                <template #item.status="{ item }">
                    <v-chip
                        v-bind="resolveStatus(item.status)"
                        small
                    >{{resolveStatus(item.status).text}}</v-chip>
                </template>


                <!-- Actions -->
                <template #item.actions="{ item }">
                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                    </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            :to="{name: 'planogram-id', params: { id: item.id }}"
                            target="_blank"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiPencilBoxOutline }}
                                </v-icon>
                                <span>Edit</span>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>

                            <v-list-item-title>
                            <v-icon
                                size="20"
                                class="me-2"
                            >
                                {{ icons.mdiDownload }}
                            </v-icon>
                            <span>Download</span>
                            </v-list-item-title>
                        </v-list-item>


                        <v-list-item
                            @click="deletePOG(item.id)"
                            v-if="$can('update','skutopia')"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiTrashCanOutline }}
                                </v-icon>
                                <span>Delete</span>
                            </v-list-item-title>
                        </v-list-item>

                        <!-- <v-list-item
                        
                        v-if="$can('update','skutopia')">
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiLayersTripleOutline }}
                                </v-icon>
                                <span>Duplicate</span>
                            </v-list-item-title>
                            </v-list-item> -->


                    </v-list>
                </v-menu>

                </template>
            </v-data-table>

        </v-card-text>
    </v-card>
    <v-dialog
        v-model="isUploadDialogVisible"
        max-width="700px"
        peristent
    >
        <v-card class="text-center px-10 py-6">
            <v-form
                ref="POGForm"
                @submit.prevent=""
            >
                <v-card-title>
                    Please select your project and upload POG file
                </v-card-title>
                <v-card-text>
                        <v-autocomplete
                            v-model="projectSelected"
                            :items="projects"
                            :loading="projectLoading"
                            :search-input.sync="projectSearch"
                            item-value="id"
                            label="Find Project"
                            outlined
                            dense
                            @change="projectSearch=''"
                            return-object>
                                <template #no-data>
                                    <p class="ml-2" style="color: gray">No results found</p>
                                </template>
                        </v-autocomplete>
                </v-card-text>
                <v-card-text>
                    <div class="flex">
                        <div class="w-full h-auto relative">
                        <div
                            ref="dropZoneRef"
                            class="cursor-pointer"
                            @click="() => openFile()"
                        >
                            <div
                            class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded"
                            >
                            <v-btn
                                oulined
                                color="secondary"
                                class="rounded"
                                size="30"
                            >
                                <v-icon
                                size="24"
                                >{{ icons.mdiTrayArrowUp }}</v-icon>
                            </v-btn>
                            <span class="text-h6">
                                Click to upload your POG File here.
                            </span>

                            </div>

                            <div class="drop-zone"
                            >
                                <v-list-item
                                    v-for="(item, index) in fileData"
                                    :key="index"
                                    @click.stop
                                >
                                    <!-- File name -->
                                    <v-list-item-title>
                                        {{ item.name }}
                                    </v-list-item-title>
                                    <!-- File extension -->
                                    <v-list-item-subtitle>
                                        {{ item.type }}
                                    </v-list-item-subtitle>

                                    <template v-slot:append>
                                        <v-list-item-action class="align-end">
                                            <v-btn
                                            @click.stop="fileData.splice(index, 1)"
                                            >X</v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </div>
                        </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        outlined
                        class="mr-2"
                        @click="initPOGUpload"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="mr-2"
                        @click="uploadPOG"
                        :disabled="!(projectSelected && projectSelected.id != undefined && fileData.length == 1)"
                    >
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <v-dialog v-model="overlayOpen" width="80%" > 
        <v-card>
            <v-card-title>
            {{ selectedPOG ? `${selectedPOG.project} - ${selectedPOG.country} - POG #${selectedPOG.id}` : '' }}
            </v-card-title>

            <SecureImage
                :src="selectedPOG.shelf_thumbnail || selectedPOG"
                :lazy_src="selectedPOG.shelf_thumbnail || selectedPOG"
                max-height="80vh"
                max-width="100%"
                contain
            >
            <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                    color="grey-lighten-4"
                    indeterminate
                ></v-progress-circular>
                </div>
            </template>
            </SecureImage>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </skutopia>
</template>

<script>
import store from '@/store'
import { onMounted, ref, onUnmounted, computed, watch } from '@vue/composition-api'
import SecureImage from '../../SecureImage.vue'

import router from '@/router'
import {
  mdiSend,
  mdiClose,
  mdiPencil,
  mdiDelete,
  mdiFormatListBulleted,
  mdiPencilBoxOutline,
  mdiDownload,
  mdiTrashCanOutline,
  mdiLayersTripleOutline,
  mdiCircle,
  mdiFoodOutline,
  mdiBeerOutline,
  mdiBabyBottleOutline,
  mdiBottleTonicPlusOutline,
  mdiHomeHeart,
  mdiToyBrickOutline,
  mdiPaw,
  mdiTshirtCrewOutline,
  mdiTrayArrowUp,
  mdiDotsVertical,
  mdiAlertCircle,
  mdiCheckCircle,
  mdiPackageVariant,
  mdiChevronUp,
  mdiChevronDown,
    mdiCloseBoxMultipleOutline
} from '@mdi/js'

import Skutopia from '@/views/apps/skutopia/Skutopia.vue'
import usePOG from '../usePOG'
import projectStoreModule from '@/views/apps/project/projectStoreModule'


export default {
    components: {
        Skutopia,
        SecureImage
    },
    setup() {


        const PROJECT_APP_STORE_MODULE_NAME = 'app-project'

        // Register module
        if (!store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.registerModule(PROJECT_APP_STORE_MODULE_NAME, projectStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
        if (store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.unregisterModule(PROJECT_APP_STORE_MODULE_NAME)
        })

        const filterDrawer = ref(false)
        const POGHeaders = ref([
            {
                text: 'POG',
                value: 'id',
            },
            {
                text: 'PROJECT',
                value: 'project',
            },
            {
                text: 'CATEGORY',
                value: 'category',
            },
            {
                text: 'PRODUCTS',
                value: 'products',
            },
            {
                text: 'STATUS',
                value: 'status'
            },
            {
                text: 'CREATION DATE',
                value: 'created_at',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
            },
        ])
        const selectedCategory = ref(null)
        const isUploadDialogVisible = ref(false)
        const fileData = ref([])

        const projectLoading = ref(false)
        const projectSelected = ref(null)
        const projectSearch = ref("")
        const dropZoneRef = ref()
        const selectedPOG = ref({})
        const overlayOpen = ref(false)
        const pogCompletedStatus = ref(false)

        const filterChange = async () => {
            pogLoading.value = true
            fetchPOGs()
        }

        const {
            planogramsData,
            resolveStatus,
            options,
            searchQuery,
            pogLoading,
            totalPOGs,
            planogramUploadLoading,
            lighthouseProjectsData,
            totalProjectListTable,

            categoryOptions,
            categoryLoading,
            categorySearch,
            fetchCategories,

            selectedMarkets,
            selectedBrands,
            getFacetOptions,

            fetchProjects,
            fetchPOGs,
            addPOG,
            deletePOG,
            validationDialogOpen,
            validationPlanogramId,
            summaryCards, 
        } = usePOG()

        const validationLoading = ref(false)
        const validationConfirming = ref(false)
        const validationRows = ref([])
        const validationConfirmations = ref({})

        const validationExactCount = computed(() => validationRows.value.filter(r => r.match_type === 'exact').length)
        const validationPartialCount = computed(() => validationRows.value.filter(r => r.match_type === 'partial').length)
        const validationNoneCount = computed(() => validationRows.value.filter(r => r.match_type === 'none').length)
        const validationResolvedCount = computed(() => Object.keys(validationConfirmations.value).length)
        const validationAllResolved = computed(() =>
        validationResolvedCount.value === validationRows.value.length && validationRows.value.length > 0
        )
        const expandedRows = ref({})

        const toggleRowExpand = (rowIndex) => {
        expandedRows.value = {
            ...expandedRows.value,
            [rowIndex]: !expandedRows.value[rowIndex]
        }
        }

        watch(validationDialogOpen, async val => {
            if (val && validationPlanogramId.value) {
                validationLoading.value = true
                validationConfirmations.value = {}
                try {
                    const response = await store.dispatch('app-skutopia/validatePOGProducts', validationPlanogramId.value)
                    validationRows.value = response.data

                    const autoConfirmed = {}
                    validationRows.value.forEach(row => {
                        if (row.match_type === 'exact') {
                            autoConfirmed[row.row_index] = {
                                row_index: row.row_index,
                                planogram_product_id: row.planogram_product_id, 
                                confirmed_product_id: row.matches[0].id,
                                create_product: false,
                                is_excluded: false,
                                original_upc: row.upc,
                                shelf: row.shelf,
                                variant: row.variant,
                            }
                        }
                    })
                    validationConfirmations.value = autoConfirmed  

                } catch (e) {
                    console.error('Validation load error:', e)
                } finally {
                    validationLoading.value = false
                }
            }
        })

        const validationSelectMatch = (row, match) => {
            validationConfirmations.value = {
                ...validationConfirmations.value,
                [row.row_index]: {
                    row_index: row.row_index,
                    planogram_product_id: row.planogram_product_id,
                    confirmed_product_id: match.id,
                    create_product: false,
                    is_excluded: false,
                    original_upc: row.upc,
                    shelf: row.shelf,
                    variant: row.variant,
                },
            }
        }

        const validationMarkNoProduct = row => {
            validationConfirmations.value = {
                ...validationConfirmations.value,
                [row.row_index]: {
                    row_index: row.row_index,
                    planogram_product_id: row.planogram_product_id, 
                    confirmed_product_id: null,
                    create_product: false,
                    is_excluded: true, 
                    original_upc: row.upc,
                    shelf: row.shelf,
                    variant: row.variant,
                },
            }
        }

        const validationMarkRemainingAsNoProduct = () => {
            const updatedConfirmations = { ...validationConfirmations.value }
            validationRows.value.forEach(row => {
                if (!updatedConfirmations[row.row_index]) {
                    updatedConfirmations[row.row_index] = {
                        row_index: row.row_index,
                        planogram_product_id: row.planogram_product_id,
                        confirmed_product_id: null,
                        create_product: false,
                        is_excluded: true, 
                        original_upc: row.upc,
                        shelf: row.shelf,
                        variant: row.variant,
                    }
                }
            })
            validationConfirmations.value = updatedConfirmations
        }

        const validationSubmit = async () => {
            validationConfirming.value = true
            try {
                const payload = Object.values(validationConfirmations.value).map(conf => ({
                    planogram_product_id: conf.planogram_product_id,
                    confirmed_product_id: conf.confirmed_product_id,
                    create_product: conf.create_product || false,
                    is_excluded: conf.is_excluded || false,
                    manual_upc: conf.original_upc,
                    manual_name: conf.variant
                }))

                await store.dispatch('app-skutopia/resolvePOGProducts', {
                    id: validationPlanogramId.value,
                    resolutions: payload,
                })
                
                validationDialogOpen.value = false
                fetchPOGs()
            } catch (e) {
                console.error('Confirm error:', e)
            } finally {
                validationConfirming.value = false
            }
        }

        const validationCancel = () => {
            validationDialogOpen.value = false
        }

        const exactMatchesExpanded = ref(false)

        const validationRowsNeedingReview = computed(() =>
        validationRows.value.filter(r => r.match_type === 'partial' || r.match_type === 'none')
        )

        const validationRowsExact = computed(() =>
        validationRows.value.filter(r => r.match_type === 'exact')
        )

        const projects = computed(() => lighthouseProjectsData.value.map(project => {
            const countries = project.countries
            return countries.map(country => {
                return {
                    id:country.id,
                    text: `${project.job_number} ${project.job_name} - ${country.country_detail.code}`,
                    job_number: project.job_number,
                    job_name: project.job_name,
                    category: project.category.name,
                    country: country.country_detail.name,
                    country_code:country.country_detail.code
                }
            })}).flat()
        )


        const initPOGUpload = () => {
            projectSelected.value = null
            projectSearch.value = ''
            fileData.value = []
            isUploadDialogVisible.value = false
        }


        const changeCategory = (category) => {
            pogLoading.value = true
            const params = {
                category: category
            }
            fetchPOGs(params)
        }

        const submitSearch = (event) => {
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault()
            }
            const params = {}

            if (searchQuery.value) {
                params.search = searchQuery.value
            }
             if (pogCompletedStatus.value) {
                params.status = 'COMP'
            }
            pogLoading.value = true
            fetchPOGs(params)
        }


        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                fileData.value = Array.from(input.files);


            };
            input.click();
        }

        const uploadPOG = async () => {
            const project = JSON.parse(JSON.stringify(projectSelected.value))
            await addPOG(project, fileData.value[0])

            isUploadDialogVisible.value = false
            fileData.value = []
            projectSelected.value = null
            
            router.push({
                name: 'planogram-id',
                params:{
                    id: validationPlanogramId.value
                }
            })
        }

        const openOverlay = (pog) => {
            selectedPOG.value = pog
            overlayOpen.value = true;
        }

        const closeOverlay = () =>  {
            overlayOpen.value = false;
            selectedPOG.value = null; // Clear the selected image
        }

        const onValidationConfirmed = () => {
        fetchPOGs()  
        }

        watch(projectSearch,
            async (val, oldVal) => {
                if (val != null && val.length > 2 && projectSelected.value == null) {

                    projectLoading.value = true
                    await fetchProjects(val)

                    projectLoading.value = false
                }
            }
        )

        onMounted(async () => {
            // await fetchPOGs()
            await fetchCategories()
        })

        
        watch([options], () => {
            fetchPOGs()
        })

        return {
            filterDrawer,
            POGHeaders,
            planogramsData,
            resolveStatus,
            options,
            searchQuery,
            pogLoading,
            totalPOGs,
            selectedCategory,
            categoryOptions,
            categoryLoading,
            categorySearch,
            isUploadDialogVisible,
            fileData,
            dropZoneRef,
            projectSelected,
            projectSearch,
            projectLoading,
            projects,
            selectedPOG,
            overlayOpen,
            pogCompletedStatus,

            initPOGUpload,
            uploadPOG,
            openFile,
            deletePOG,
            openOverlay,
            closeOverlay,
            submitSearch,
            changeCategory,
            onValidationConfirmed,
            validationMarkRemainingAsNoProduct,
            validationDialogOpen,
            validationPlanogramId,

            validationLoading,
            validationConfirming,
            validationRows,
            validationConfirmations,
            validationExactCount,
            validationPartialCount,
            validationNoneCount,
            validationResolvedCount,
            validationAllResolved,
            validationSelectMatch,
            validationMarkNoProduct,
            validationSubmit,
            validationCancel,
            toggleRowExpand,
            expandedRows,
            exactMatchesExpanded,
            validationRowsNeedingReview,
            validationRowsExact,
            selectedMarkets,
            selectedBrands,
            getFacetOptions,
            filterChange,
            summaryCards, 

            icons: {
                mdiSend,
                mdiPencilBoxOutline,
                mdiDownload,
                mdiTrashCanOutline,
                mdiLayersTripleOutline,
                mdiDotsVertical,
                mdiCircle,
                mdiTrayArrowUp,
                mdiClose,
                mdiPencil,
                mdiDelete,
                mdiFormatListBulleted,
                mdiAlertCircle,
                mdiCheckCircle,
                mdiPackageVariant,
                mdiChevronUp,
                mdiChevronDown,
                mdiCloseBoxMultipleOutline
            }
        }
    }

}
</script>


<style lang="scss" scoped>
.drop-zone {
  border: 1px dashed rgba(33,33,33, 0.4);
}

.border-warning { border-color: #fb8c00 !important; }
.border-error { border-color: #f44336 !important; }
.border-success { border-color: #4caf50 !important; }

</style>